<template>
  <div>
    <v-card class="white rounded-lg">
      <v-card-title class="success--text" style="font-size: small">{{title}}</v-card-title>
      <v-card-text>
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     @dblclick:row="(e, row) => $router.push(to(row.item))"
                     ref="datatable" :show-select="false">
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>

        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
export default {
  name: "NoContentProductList",
  components: {},
  props: {
    isSummary : {
      default: false
    }
  },
  data() {
    return {
      url: "product/product/noContent",
      filters: {},
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('محصولات در انتظار محتوا')
    },

    headers() {
      return [
        {
          text: "بارکد",
          value: "barcode",
        },
        {
          text: "نام",
          value: "name",
          max_length: 100
        },
        {
          show: !this.isSummary,
          text: "تصویر ",
          value: "has_picture",
          type:"boolean"
        },
        {
          show: !this.isSummary,
          text: "توضیحات ",
          value: "has_explanation",
          type:"boolean"
        },
        {
          show: !this.isSummary,
          text: "توضیحات مختصر ",
          value: "has_summary_explanation",
          type:"boolean"
        },
        {
          show: !this.isSummary,
          text: "نحوه مصرف ",
          value: "has_how_to_use",
          type:"boolean"

        },

      ];

    },
  },
  methods: {
    to(item) {
      return {
        name: "ProductContentDevelopmentDetail",
        params: {
          id: item.id,
        },
      };
    },

  },
};
</script>

<style scoped lang="scss">
</style>